import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core'

import { INSPECTION_TYPE_CATEGORY_LIST } from 'src/app/constants/internationalized-constants-en'

@Component({
  selector: 'app-inspection-type-description-dialog',
  templateUrl: './inspection-type-description-dialog.component.html',
  styleUrls: ['./inspection-type-description-dialog.component.scss'],
})
export class InspectionTypeDescriptionDialogComponent implements AfterViewInit {

  inspectionTypeDescriptions = INSPECTION_TYPE_CATEGORY_LIST

  @ViewChild('okButton', { read: ElementRef }) okButton: ElementRef<HTMLElement>

  constructor() { }

  ngAfterViewInit(): void {
    if (this.okButton) {
      setTimeout(() => this.okButton.nativeElement.focus(), 50)
    }
  }
}
